import { useEffect, useState, useContext, useRef } from 'react'
import { motion } from 'framer-motion'
import { useTheme } from '@mui/material/styles'
import Logo from '../../assets/logo'
import { Foot } from './foot'
import { Outlet, Link } from 'react-router-dom'

import './head.css'

import { Button } from '@mui/material'
import MobileMenu from '../components/mobile-menu'

export const Head = ({ user }) => {
  const theme = useTheme()

  return (
    <>
      <header className='flex items-center h-16 px-4 border-b gap-4 w-full md:px-6'>
        <Link className='flex items-center gap-2 font-semibold' to='/'>
          <Logo width={150} />
        </Link>
        <Link className='font-semibold' to='/'>
          for the Harvard Community
        </Link>
        <nav className='flex-1 justify-center hidden gap-6 md:flex'>
          <Link className='font-semibold' to='/groups'>
            Groups
          </Link>
          <Link className='font-semibold' to='/about'>
            About
          </Link>
          <Link className='font-semibold' to='/more-info'>
            Answers
          </Link>
          <Link className='font-semibold' to='/terms'>
            Terms
          </Link>
          <Link className='font-semibold' to='/demos'>
            Demos
          </Link>
        </nav>
        <div className='ml-auto flex items-center gap-4'>
          <Link to='https://app.joinu.org'>
            <Button variant='contained'>Login</Button>
          </Link>
        </div>
        <MobileMenu />
        
      </header>
      <body className='w-full'>
        <Outlet />
        <Foot />
      </body>
    </>
  )
}
